<template>
    <page title="You have been logged out">
        Successfully logged out!
    </page>
</template>

<script>
import Page from './utilities/Page'
import { mapGetters } from 'vuex'
import { API } from '../api/axios'

export default {
  name: 'Logout',
  components: {Page},
  computed: {
    ...mapGetters(['language']),
  },
  mounted () {
    console.log('Logging out user...')
    API.get('/users/logout')
      .then(() => {
        this.$store.commit('changeUserData', {
          id: null,
          firstname: null,
          middlename: null,
          lastname: null,
          licenseplate: null,
          address: null,
          housenumber: null,
          zipcode: null,
          city: null,
          country: null,
          token: null,
          email: null,
          preferredlanguage: this.language,
        })
        console.log('User logged out!')
      })
      .catch(error => {
        console.log('Error logging out!', error)
      })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Logout.vue